import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import List from 'semantic-ui-react/dist/commonjs/elements/List';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import { logoutRequest } from '@Redux/actions/authentication';
import PropTypes from 'prop-types';
import { AuthLink } from '@Components';
import UserFlowTimeline from '../../components/timeline/UserFlowTimeline';
import {
  AUTHORIZATIONS,
  BASE_URL,
  DASHBOARD_URL,
  HISTORY_URL,
  INSTAPOINTS_URL,
  PAYEE_LIST_URL,
  REFERRAL_URL,
  SUBSCRIPTION_URL,
  TRANSFER_MONEY_URL,
  USER_PROFILE_URL,
  INDIVIDUAL,
  MULTIPLE_TRANSACTION_URL,
  APPROVED,
  MANAGE_PAYMENT_OPTION_URL,
  CORPORATE,
  INITIATED,
  AMAZE_URL,
  Images,
  HK,
  US,
  SG,
  AU,
  MY_INFO_RESGISTRATION_URL,
  POST_LOGOUT_URL,
  UK,
  EU_REGION,
  CORPORATE_CUSTOMER_SUPPORT_EMAIL,
  USER_REGISTRATION_URL,
  NIUM_FOREX_URL_SEND_MONEY,
  NIUM_FOREX_URL,
  HEADER_FOOTER_IGNORED_URLS,
  SCREEN_NAME_SSN,
  SCREEN_NAME_DOCUMENT_UPLOAD,
  EU,
  CONSENT_PERMISSION_URL,
  DEVICE_MOBILE,
  EMAIL_VERIFICATION_URL,
  APP_ONLY_CORRIDOOR_WELCOME_URL,
  NIUM_FOREX_HELP_EMAIL_MESSAGE,
  ADD_PAYEE_URL
} from '../../utils/constants';
import {
  changeScreen,
  destroyUserFlowAction
} from '../../redux/actions/user-flow/user-flow-action';
import { STORE_DHA_CHALLAN_DATA, USER_FLOW_JUMP_TO } from '../../redux/action-contants';
import {
  getContentSchemaFromContentFul,
  resetTransactionDetails
} from '../../redux/actions/common/common-action';
import NotificationBell from '../notification-bell/NotificationBell';
import { toggleSidebar } from '../../redux/actions/ui-trigger/ui-trigger-action';
import './header.css';
import ToggleFeatureProvider, { ToggleFeatureConsumer } from '../../toggleFeature';
import styled from 'styled-components';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import RenderStaticTimeline from './staticNavigation';
import {
  getLottieJson,
  isAmazeFlow,
  isKYCSplitFlow,
  isBirthdayWeek,
  isNewOnboardingEnabledCountry,
  shouldShowPaymentOptionTab
} from '../../utils/library';
import HelpCenterDecide from '../HelpCenterNavigation/HelpcenterNavSwitch';
import { FLOW_TYPE_SEND_MONEY, SEND_MONEY } from '../../utils/constants/eventsConstants';
import moment from 'moment';
import Lottie from 'react-lottie-player';
import COLORS from '../../common/styles/color-pallete';
import ServiceUnavailable from '../indiaServiceUnavailable/ServiceUnavailable';
import { ModalFactory } from '../modal/modal';
import { NF_SCREENS } from '../../screens/nium-forex/root/screenConstants';
import {
  setZenDeskActiveChat,
  toggleIsRevampApiCalled
} from '../../redux/actions/help-center-action/help-center-actions';
import { logEvent, logEventV2, getPageName } from '../../utils/events/logUserEvents';
import {
  EventButtonType,
  EventNamesV2,
  FLOW_TYPE,
  LOG_TYPE
} from '../../utils/events/eventsConstants';
import {
  BACK_ARROW_ICON,
  FAQ_ICON,
  LOGOUT_ICON,
  MANAGE_PAYMENT_OPT_ICON,
  MY_ACCOUNT_ICON,
  NEW_INSTAREM_LOGO_ICON,
  NEWBACKWITHOUT_CIRCLE_ICON,
  RECIPIENT_ICON,
  SBM_LOGO_SVG_ICON,
  SEND_MONEY_ICON,
  SUBSCRIPTION_ICON,
  UNREAD_INDICATOR_ICON,
  REFERRAL_SMALL_ICON
} from '@Images';
import { toggleNewCouponCode } from '@Redux/actions/transaction';
import { storeSelectedBeneList } from '../../redux/actions/transaction/transaction-action';
import { clearDashboardCalculatorData } from '@Redux/actions/dashboard';
import withRouterV6 from '../common/withRouterV6';

const GridRow = styled(Grid.Row)`
  ${(p) =>
    p.$fixHeader &&
    `
  height: 140px;
  background-color: ${COLORS.white};
  `}

  ${(p) =>
    p.$twoFactorTokenCheck &&
    `
    border: solid 1px #eaeaea;
  `}

  ${(p) =>
    p.$toggleFeature &&
    p.$isMobile &&
    `
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: ${COLORS.white};
  `}
`;

class HeaderNavbar extends Component {
  onNotificationStateUpdate = (state, close) => {
    this.setState({ notification: state });
    this.closeNotification = close;
  };

  toggleMenu = () => this.setState({ openMenu: !this.state.openMenu });

  disableZendesk = () => {
    const { zE: zenDesk } = window;
    if (zenDesk) {
      zenDesk('messenger', 'logoutUser');
      this.props.setZenDeskActiveChat(false);
    }
  };
  logCTEvents = (ctaName, flowType) => {
    const eventProperty = {
      type: EventButtonType.BUTTON,
      pageName: getPageName(),
      ctaName,
      flowType
    };
    logEventV2(EventNamesV2.CTA_CLICKED, eventProperty);
  };

  logout = async () => {
    const { logoutRequest, account_type, navigate } = this.props;
    this.logCTEvents('Logout', FLOW_TYPE.LOGOUT);

    const response = await logoutRequest();
    if (account_type === INDIVIDUAL && response?.data?.success) {
      this.disableZendesk();
      this.props.toggleIsRevampApiCalled(false);
      navigate(POST_LOGOUT_URL);
    }
  };

  shownNavLinkAddPayee = () => {
    const { currentScreen } = this.props;
    if (
      window.location.pathname === ADD_PAYEE_URL ||
      (window.location.pathname === TRANSFER_MONEY_URL && currentScreen === 'add_beneficiary')
    )
      return false;

    return true;
  };

  onSendMoney = () => {
    const {
      user_status: { status, country_code },
      navigate,
      location
    } = this.props;
    if (country_code === 'IN') {
      this.handleServiceUnavailable(status);
    } else {
      logEvent(SEND_MONEY, FLOW_TYPE_SEND_MONEY);
      // Clear coupon Code data and Dashboard calculator data
      this.props.toggleNewCouponCode(false);
      this.props.clearDashboardCalculatorData();

      const current_path = location.pathname;
      let { currentScreen, screens, timeline } = this.props;
      if (current_path === TRANSFER_MONEY_URL && currentScreen === 'send-money') {
        //user standing on same route and same screen
        return;
      } else if (current_path === TRANSFER_MONEY_URL && currentScreen !== 'send-money') {
        //user standing on same route but different screen
        this.props.resetTransactionDetails();
        this.props.changeScreen(USER_FLOW_JUMP_TO, 'send_money', screens, timeline);
      } else {
        //user standing on different route than /transfer-money
        this.props.resetTransactionDetails();
        if (this.props.account_type === INDIVIDUAL) {
          navigate(TRANSFER_MONEY_URL);
        } else {
          navigate(MULTIPLE_TRANSACTION_URL);
        }
      }
    }
  };
  handleServiceUnavailable = async () => {
    return await ModalFactory.builder(
      (onClose) => <ServiceUnavailable onClose={onClose} />,
      'send-money-bene-modal insta-modal center-modal',
      true
    );
  };

  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
      notification: false,
      noNavigation: false, // for react-native web view no header
      navbarLogo: NEW_INSTAREM_LOGO_ICON,
      isLogoLottieFile: false,
      dynamicLogoClass: false
    };
    this.myAccount = null;
  }

  componentDidUpdate(prevProps) {
    let { provideToggleMenuParams, account_type, country_code } = this.props;
    provideToggleMenuParams && provideToggleMenuParams(this);
    if (country_code !== prevProps.country_code || account_type !== prevProps.account_type) {
      [INDIVIDUAL].includes(account_type) && this.getDynamicLogo();
    }
  }

  getDynamicLogoDetails = (dynamicLogoContent, country_code) => {
    let isEventDate = false;
    const countryLogoDetails = dynamicLogoContent?.eventList?.value?.filter(
      (element) => element?.target?.fields?.countryCode?.value === country_code
    );
    if (isBirthdayWeek()) {
      if (
        countryLogoDetails?.length > 0 &&
        countryLogoDetails[0]?.target?.fields?.birthdayLogoLightMode
      ) {
        const birthdayLogoLightMode = countryLogoDetails[0]?.target?.fields?.birthdayLogoLightMode;
        if (birthdayLogoLightMode?.target?.fields) {
          const { mime, url } = birthdayLogoLightMode?.target?.fields || '';
          isEventDate = true;
          return { isEventDate, mime, url };
        }
      } else {
        //Same Birthday logo for all countries if the country is included in list
        const isCountrySupported =
          dynamicLogoContent?.birthdayfeatureSupportingCountry?.value?.includes(country_code);
        if (isCountrySupported) {
          const birthdayLogoLightMode = dynamicLogoContent?.birthdayDefaultLogoLightMode;
          if (birthdayLogoLightMode?.target?.fields) {
            const { mime, url } = birthdayLogoLightMode?.target?.fields || '';
            isEventDate = true;
            return { isEventDate, mime, url };
          }
        }
      }
      return { isEventDate };
    }

    //Instagram logo specific to event
    if (countryLogoDetails?.length > 0 && countryLogoDetails[0]?.target?.fields?.countryEventList) {
      const countryEventList = countryLogoDetails[0]?.target?.fields?.countryEventList?.value;
      if (countryEventList) {
        for (let itr = 0; itr < countryEventList.length; itr++) {
          const { appLogoLightMode, endDate, startDate } =
            countryEventList[itr]?.target?.fields || '';
          const now = new Date();
          const dateString = moment(now).format('YYYY-MM-DD');
          if (startDate && endDate)
            isEventDate =
              [startDate.value, endDate.value].includes(dateString) ||
              moment(dateString).isBetween(startDate.value, endDate.value);
          if (isEventDate && appLogoLightMode?.target?.fields) {
            const { mime, url } = appLogoLightMode?.target?.fields || '';
            return { isEventDate, mime, url };
          }
        }
      }
    }
    return { isEventDate };
  };

  getDynamicLogo = async () => {
    const dynamicLogoContent = await getContentSchemaFromContentFul(
      'componentEventList',
      'MOBILE_EVENT_LIST'
    );
    const { country_code } = this.props;
    const userCountryCode = EU.includes(country_code) ? 'EU' : country_code;
    const { isEventDate, mime, url } = this.getDynamicLogoDetails(
      dynamicLogoContent,
      userCountryCode || ''
    );
    if (isEventDate) {
      if (mime && url && mime.includes('application/json')) {
        const lottieJson = await getLottieJson(url);
        await this.setState({
          isLogoLottieFile: true,
          navbarLogo: lottieJson,
          dynamicLogoClass: true
        });
      } else if (url)
        this.setState({ isLogoLottieFile: false, navbarLogo: url, dynamicLogoClass: true });
    } else this.setState({ isLogoLottieFile: false });
  };

  componentDidMount() {
    window.addEventListener('scroll', debounce(this.listenToScroll, 5));
    if ((window && window.ReactNativeWebView) || (window && window.WebViewBridge)) {
      this.setState({ noNavigation: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll);
  }

  listenToScroll = () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const fixHeader = winScroll > 135 ? true : false;

    this.setState({
      fixHeader
    });
  };

  goToDashboard = () => {
    const { destroyUserFlowAction, navigate } = this.props;
    destroyUserFlowAction();
    navigate(DASHBOARD_URL);
  };

  renderLogo = (isSbmReferral) => {
    return isSbmReferral ? (
      <h1 title="SbmBank" className="brand-logo-wrapper">
        <a
          href="https://www.sbmbank.co.in/"
          rel="noopener noreferrer"
          title="SbmBank"
          target="_blank"
        >
          <img onClick={this.goToDashboard} src={SBM_LOGO_SVG_ICON} alt="" className="brand-logo" />
        </a>
      </h1>
    ) : (
      <h1 title="InstaRem" className="brand-logo-wrapper">
        <a
          href="#!"
          onClick={(e) => {
            e.preventDefault();
            if (window.location.href.includes(NIUM_FOREX_URL_SEND_MONEY)) {
              this.props.navigate('/');
            }
          }}
          title="InstaRem"
          target="_blank"
        >
          {this.state.isLogoLottieFile ? (
            <Lottie
              loop={true}
              play={true}
              animationData={this.state.navbarLogo}
              rendererSettings={{ preserveAspectRatio: 'xMinYMin meet' }}
              onComplete={null}
              className="event-brand-logo"
              onClick={this.goToDashboard}
            />
          ) : (
            <img
              onClick={this.goToDashboard}
              src={this.state.navbarLogo}
              alt="instarem-logo"
              className={this.state.dynamicLogoClass ? 'event-brand-logo' : 'brand-logo'}
            />
          )}
        </a>
      </h1>
    );
  };

  cleverTapEvent = (eventName) => {
    let ctData = {
      pageName: 'Settings'
    };
    logEvent(eventName, null, ctData, LOG_TYPE.CLEVER_TAP);
    this.toggleMenu();
  };
  onLinkClick = (targetUrl) => {
    const { destroyUserFlowAction } = this.props;
    this.toggleMenu();
    destroyUserFlowAction();
    if (this.props.transactionDetails?.selectedBene?.is_dha_beneficiary) {
      this.props.storeSelectedBeneList({});
      this.props.clearDhaChallanData();
    }
    if (targetUrl === DASHBOARD_URL) {
      // Clear coupon Code data and Dashboard calculator data
      this.props.toggleNewCouponCode(false);
      this.props.clearDashboardCalculatorData();
    }
  };
  handleSpanOnClick = () => {
    this.handleServiceUnavailable();
  };
  render() {
    let {
        currentScreen,
        timeline,
        screens,
        account_type,
        user_session,
        featureState,
        location,
        country_code,
        hard_sme_migrated,
        nonHardMigratedSMEFlow,
        headerRef,
        userStatusReducer: { status },
        help_center_notification,
        isNewOnboardingEnabledUser,
        isNiumForexUser,
        niumForexCurrentScreen,
        additional_info,
        email
      } = this.props,
      { pathname } = location,
      // static check for SG flow with Add recipient for not showing transaction timeline
      isRecipientScreen = featureState?.toggleFeature && currentScreen === 'add_beneficiary',
      isTimelineRequired =
        !isRecipientScreen &&
        timeline &&
        timeline[0] &&
        timeline[0].label &&
        timeline[0].timeline_sequence;
    const isAckScreen =
      location.pathname === `${BASE_URL}/acknowledgement/none/awaiting/` ||
      location.pathname === `${BASE_URL}/acknowledgement/none/approved/`;
    const isUserApproved = this.props.userStatusReducer.status === APPROVED && isAckScreen;
    const isSbmReferral = get(
      this.props,
      'transactionDetails.additional_info.is_sbm_referral',
      false
    );
    const isDashboard =
      location.pathname === DASHBOARD_URL ||
      (location.pathname === NIUM_FOREX_URL && niumForexCurrentScreen === NF_SCREENS.send_money);
    const isPreDashboard =
      location.pathname === NIUM_FOREX_URL &&
      niumForexCurrentScreen === NF_SCREENS.mobile_verification;
    const isCrossSellPage = [
      NF_SCREENS.cross_selling,
      NF_SCREENS.cross_selling_form,
      NF_SCREENS.cross_selling_success
    ].includes(niumForexCurrentScreen);
    const isForexStepPage =
      location?.pathname?.includes(NIUM_FOREX_URL) &&
      niumForexCurrentScreen !== NF_SCREENS.send_money &&
      !isCrossSellPage &&
      !isPreDashboard;
    const isNewKYCFlow = isKYCSplitFlow(
      country_code,
      this.props.userStatusReducer.status,
      true,
      account_type
    );
    const isStatusApproved = [APPROVED].includes(this.props.userStatusReducer.status);
    const isUserApprovedAndDashboardScreen = (isStatusApproved || isNewKYCFlow) && isDashboard;

    const noTimelineForCorp =
      [APPROVED, INITIATED].includes(this.props.userStatusReducer.status) &&
      isAckScreen &&
      this.props.userStatusReducer.account_type === CORPORATE;
    const timelineDisabledPaths = [MY_INFO_RESGISTRATION_URL];
    if (!HEADER_FOOTER_IGNORED_URLS.includes(pathname)) {
      const isHeaderDisabled = /signin|signup|invite\/|password|logout|feedback\//gi.test(pathname);
      if (isHeaderDisabled || pathname === BASE_URL) return null;
    }

    let isIndividual = account_type === INDIVIDUAL;
    const { MY_ACCOUNT_SETTINGS_ICON_SBM } = Images;
    const isClient = typeof window === 'object';
    const width = isClient ? window.innerWidth : undefined;
    const blueHeaderStyle = {
      backgroundColor: '#001F8F'
    };
    const twoFactorTokenCheck =
      location.state && location.state.twoFA && location.state.accountType === 'INDIVIDUAL';
    const isTwoFactorCorpCheck = location.state && location.state.twoFA;
    const isREKYC =
      this.props.userStatusReducer.status === INITIATED &&
      this.props.userStatusReducer.sub_status === 'REKYC';
    const showManagePayment = [HK, US, SG, UK, AU, ...EU_REGION];
    const showManagePaymentCorporate = [US];

    const paymentOptionTabVisible = shouldShowPaymentOptionTab(country_code);

    //Setting default value to false
    let smeFlow = false;
    if (nonHardMigratedSMEFlow?.isFeatureEnabled && account_type === CORPORATE) {
      //if country_code is present in list
      const { data } = nonHardMigratedSMEFlow;
      smeFlow = data.includes(country_code) && status === APPROVED;
    }
    const newOnBoardingUI = isNewOnboardingEnabledCountry(country_code);
    const renderTimeLine = () => {
      if (
        newOnBoardingUI &&
        isNewOnboardingEnabledUser &&
        location?.pathname === USER_REGISTRATION_URL
      ) {
        return false;
      } else {
        return true;
      }
    };

    const isUsNewFlow = () => {
      /* Check for the timeline after Ssn verification in US corridor in case od doc verification
         hiding the timeline in new onboarding flow */
      const isUsIndividual = account_type === INDIVIDUAL && country_code === US;
      if (isUsIndividual && SCREEN_NAME_DOCUMENT_UPLOAD === currentScreen) {
        return false;
      } else if (
        additional_info?.ssn_verification_attempts >= 2 &&
        isUsIndividual &&
        SCREEN_NAME_SSN === currentScreen
      ) {
        return false;
      }
      return true;
    };
    const renderHelpForNiumForexUser = () => {
      return (
        <List.Content className="list-content">
          <div className="icon">
            <img alt="faq" src={FAQ_ICON} />
          </div>
          <a
            href={`mailto:${NIUM_FOREX_HELP_EMAIL_MESSAGE.email}?subject=${encodeURIComponent(
              `${NIUM_FOREX_HELP_EMAIL_MESSAGE.subject}${email}`
            )}&body=${encodeURIComponent(`${NIUM_FOREX_HELP_EMAIL_MESSAGE.body}`)}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Help
          </a>
        </List.Content>
      );
    };

    const isAppOnlyCorridorRoute = window.location.href.includes(APP_ONLY_CORRIDOOR_WELCOME_URL);
    return (
      <div ref={headerRef}>
        {!window.location.href.includes(CONSENT_PERMISSION_URL) && (
          <Grid
            centered
            id={'header'}
            style={{ border: twoFactorTokenCheck ? 'solid 1px #eaeaea' : 'none' }}
          >
            <GridRow
              className="navbar"
              $toggleFeature={featureState && featureState.toggleFeature}
              $fixHeader={this.state.fixHeader}
              $isMobile={width < 600 ? true : false}
              id={'sticky-header'}
              $twoFactorTokenCheck={isTwoFactorCorpCheck}
              $isBlue={true}
              style={isSbmReferral ? blueHeaderStyle : null}
            >
              <Grid.Column computer={15} mobile={16} className="header-navbar-wrapper">
                <div
                  className={`header-navbar ${
                    isNiumForexUser && isForexStepPage ? 'header-navbar-center' : ''
                  }`}
                >
                  <div className="LogoWrapper">
                    {this.renderLogo(isSbmReferral)}
                    {isTwoFactorCorpCheck && window.innerWidth < 500 && (
                      <img
                        className="backImg"
                        onClick={() => this.props.navigate(-1)}
                        src={twoFactorTokenCheck ? NEWBACKWITHOUT_CIRCLE_ICON : BACK_ARROW_ICON}
                        alt="Go Back"
                        width={twoFactorTokenCheck ? '12px' : '23px'}
                        height="23px"
                      />
                    )}
                  </div>
                  {(isNiumForexUser
                    ? !isForexStepPage && !isPreDashboard
                    : (!currentScreen || !isTimelineRequired || isUserApprovedAndDashboardScreen) &&
                      !timelineDisabledPaths.includes(pathname) &&
                      !(hard_sme_migrated || smeFlow)) &&
                    this.shownNavLinkAddPayee() &&
                    !isAppOnlyCorridorRoute && (
                      <nav className={'header-nav'}>
                        <ul>
                          <li>
                            {country_code === 'IN' &&
                            account_type === INDIVIDUAL &&
                            !isNiumForexUser ? (
                              <span
                                style={{ cursor: 'pointer' }}
                                className="header-links"
                                onClick={this.handleSpanOnClick}
                              >
                                {'Send money'}
                              </span>
                            ) : (
                              <AuthLink
                                className="header-links"
                                caption={'Send money'}
                                target_path={
                                  account_type === INDIVIDUAL
                                    ? TRANSFER_MONEY_URL
                                    : MULTIPLE_TRANSACTION_URL
                                }
                                id="link-send-money"
                                onClick={this.onSendMoney}
                              />
                            )}
                          </li>
                          {isAmazeFlow(country_code, account_type) && (
                            <li>
                              <AuthLink
                                className="header-links"
                                caption={'amaze'}
                                target_path={AMAZE_URL}
                                id="link-amaze-sg"
                              />
                            </li>
                          )}
                          {isNiumForexUser && (
                            <li>
                              <AuthLink
                                className="header-links"
                                caption={'Send money'}
                                target_path={NIUM_FOREX_URL}
                                id="link-nium-forex-send-money"
                              />
                            </li>
                          )}
                          <li>
                            <AuthLink
                              className="header-links"
                              caption={'Recipients'}
                              target_path={PAYEE_LIST_URL}
                              id="link-payee-list"
                            />
                          </li>
                          <li>
                            <AuthLink
                              className="header-links"
                              caption={'History'}
                              target_path={HISTORY_URL}
                              id="link-transaction-history"
                            />
                          </li>
                          {isIndividual && !isNiumForexUser && (
                            <li>
                              <AuthLink
                                className="header-links"
                                caption={'InstaPoints'}
                                target_path={INSTAPOINTS_URL}
                                id="link-referral"
                              />
                            </li>
                          )}
                          {isIndividual && (
                            <li>
                              <AuthLink
                                className="header-links"
                                caption={'Refer & earn'}
                                target_path={REFERRAL_URL}
                                id="link-referral"
                                onClick={() =>
                                  this.logCTEvents('Refer & earn', FLOW_TYPE.REFERRALS)
                                }
                              />
                            </li>
                          )}
                        </ul>
                      </nav>
                    )}
                  {!this.state.noNavigation && timelineDisabledPaths.includes(pathname) && (
                    <RenderStaticTimeline />
                  )}

                  {!twoFactorTokenCheck &&
                    !window.location.href.includes(NIUM_FOREX_URL_SEND_MONEY) &&
                    !window.location.href.includes(EMAIL_VERIFICATION_URL) && (
                      <div className="options">
                        {(isNiumForexUser
                          ? !isForexStepPage && !isPreDashboard
                          : !(hard_sme_migrated || smeFlow) && this.props.user_status.status) && (
                          <NotificationBell
                            isSbmReferral={isSbmReferral}
                            onNotificationStateUpdate={this.onNotificationStateUpdate}
                          />
                        )}
                        {!this.state.noNavigation && (!isNiumForexUser || !isForexStepPage) && (
                          <Popup
                            id="user-name-popup"
                            on="click"
                            position="bottom center"
                            style={{
                              width: '250px',
                              top: '65px',
                              right: '3.6%',
                              left: 'auto',
                              border: '1px solid #f5f5f5',
                              boxShadow: '3px 3px 0px 0px rgba(0,0,0,.07)',
                              transform: 'translateZ(0)',
                              zIndex: 6
                            }}
                            open={this.state.openMenu && this.props.device !== DEVICE_MOBILE}
                            onOpen={() => {
                              this.toggleMenu();
                            }}
                            onClose={this.toggleMenu}
                            trigger={
                              <div className="header-links">
                                <img
                                  src={
                                    isSbmReferral ? MY_ACCOUNT_SETTINGS_ICON_SBM : MY_ACCOUNT_ICON
                                  }
                                  alt="account settings icon"
                                  className="menu-drop-white"
                                  ref={(node) => (this.myAccount = node)}
                                />
                                {help_center_notification && (
                                  <img
                                    className="badge"
                                    src={UNREAD_INDICATOR_ICON}
                                    alt="Unread Indicator"
                                  />
                                )}
                              </div>
                            }
                            content={
                              <div className="account-pop-up-wrapper">
                                <span className="my-account-heading">My account</span>
                                <List divided className="pop-up-list" id="pop-up-list-header">
                                  <List.Item>
                                    {!isAppOnlyCorridorRoute &&
                                      !isPreDashboard &&
                                      !(hard_sme_migrated || smeFlow) && (
                                        <>
                                          {!isNiumForexUser && (
                                            <List.Content className="list-content">
                                              <div className="icon">
                                                <img alt="dashboard" src={SEND_MONEY_ICON} />
                                              </div>
                                              <Link
                                                to={DASHBOARD_URL}
                                                className="head"
                                                onClick={() => {
                                                  this.logCTEvents(
                                                    'Dashboard',
                                                    FLOW_TYPE.DASHBOARD
                                                  );
                                                  this.onLinkClick(DASHBOARD_URL);
                                                }}
                                              >
                                                Dashboard
                                              </Link>
                                            </List.Content>
                                          )}
                                          <List.Content className="list-content">
                                            {((authorized) => [
                                              <div key={'icon'} className="icon">
                                                <img
                                                  alt="user-profile"
                                                  src={RECIPIENT_ICON}
                                                  className={!authorized ? ' disabled' : ''}
                                                />
                                              </div>,
                                              <Link
                                                key={'link'}
                                                to={USER_PROFILE_URL}
                                                id="link-user-profile"
                                                className={
                                                  'head' + (!authorized ? ' disabled' : '')
                                                }
                                                onClick={(e) => {
                                                  if (!authorized) return e.preventDefault();
                                                  this.onLinkClick();
                                                }}
                                              >
                                                {'My info'}
                                              </Link>
                                            ])(
                                              AUTHORIZATIONS[this.props.user_status.status] &&
                                                AUTHORIZATIONS[this.props.user_status.status].find(
                                                  (text) => text === USER_PROFILE_URL
                                                )
                                            )}
                                          </List.Content>
                                          {this.props.user_status &&
                                            this.props.user_status.status === APPROVED &&
                                            ((showManagePayment.includes(this.props.country_code) &&
                                              account_type === INDIVIDUAL) ||
                                              (showManagePaymentCorporate.includes(
                                                this.props.country_code
                                              ) &&
                                                account_type === CORPORATE)) &&
                                            paymentOptionTabVisible && (
                                              <List.Content className="list-content">
                                                <div className="icon">
                                                  <img
                                                    alt="Manage payment icon"
                                                    src={MANAGE_PAYMENT_OPT_ICON}
                                                  />
                                                </div>
                                                <Link
                                                  to={MANAGE_PAYMENT_OPTION_URL}
                                                  className="head"
                                                  onClick={this.onLinkClick}
                                                >
                                                  Manage payment options
                                                </Link>
                                              </List.Content>
                                            )}
                                          {!isNiumForexUser && (
                                            <List.Content className="list-content">
                                              <div className="icon">
                                                <img
                                                  alt="Subscription icon"
                                                  src={SUBSCRIPTION_ICON}
                                                />
                                              </div>
                                              <Link
                                                to={SUBSCRIPTION_URL}
                                                className="head"
                                                onClick={this.onLinkClick}
                                              >
                                                Subscription
                                              </Link>
                                            </List.Content>
                                          )}
                                          {!isNiumForexUser &&
                                            this.props.user_status?.status !== APPROVED &&
                                            account_type !== CORPORATE && (
                                              <List.Content className="list-content">
                                                <div className="icon">
                                                  <img
                                                    alt="Referral icon"
                                                    src={REFERRAL_SMALL_ICON}
                                                  />
                                                </div>
                                                <Link
                                                  to={REFERRAL_URL}
                                                  className="head"
                                                  onClick={this.onLinkClick}
                                                >
                                                  Referrals
                                                </Link>
                                              </List.Content>
                                            )}
                                        </>
                                      )}
                                    {isNiumForexUser ? (
                                      renderHelpForNiumForexUser()
                                    ) : !isAppOnlyCorridorRoute ? (
                                      isIndividual ? (
                                        <List.Content
                                          className="list-content"
                                          id="settings_help_centre_button"
                                        >
                                          <div className="icon">
                                            <img alt="faq" src={FAQ_ICON} />
                                          </div>
                                          <HelpCenterDecide cleverTapEvent={this.cleverTapEvent} />
                                        </List.Content>
                                      ) : (
                                        <List.Content className="list-content">
                                          <div className="icon">
                                            <img alt="faq" src={FAQ_ICON} />
                                          </div>
                                          <a
                                            href={`mailto:${CORPORATE_CUSTOMER_SUPPORT_EMAIL}`}
                                            rel="noopener noreferrer"
                                            target="_blank"
                                          >
                                            Help
                                          </a>
                                        </List.Content>
                                      )
                                    ) : null}
                                    <List.Content className="list-content">
                                      <div className="icon">
                                        <img alt="logout" src={LOGOUT_ICON} />
                                      </div>
                                      <div
                                        className="head"
                                        style={{ cursor: 'pointer' }}
                                        onClick={this.logout}
                                        id="btn-logut"
                                      >
                                        Logout
                                      </div>
                                    </List.Content>
                                  </List.Item>
                                </List>
                              </div>
                            }
                          />
                        )}
                        {(!isNiumForexUser || !isForexStepPage) && (
                          <div
                            className="header-settings"
                            onClick={() => {
                              this.props.toggleSidebar();
                            }}
                          >
                            <img
                              src={MY_ACCOUNT_ICON}
                              alt="account settings icon"
                              className="menu-drop-white"
                              ref={(node) => (this.myAccount = node)}
                            />
                            {help_center_notification && (
                              <img
                                className="badge"
                                src={UNREAD_INDICATOR_ICON}
                                alt="Unread Indicator"
                              />
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  {currentScreen &&
                    renderTimeLine() &&
                    isUsNewFlow() &&
                    isTimelineRequired &&
                    !isUserApproved &&
                    !noTimelineForCorp &&
                    !isREKYC &&
                    !isDashboard &&
                    !timelineDisabledPaths.includes(pathname) && (
                      <ToggleFeatureProvider>
                        <ToggleFeatureConsumer>
                          <UserFlowTimeline
                            user_session={user_session}
                            currentScreen={currentScreen}
                            screens={screens}
                            timeline={timeline}
                            referred_by_referral_code={this.props.referred_by_referral_code}
                          />
                        </ToggleFeatureConsumer>
                      </ToggleFeatureProvider>
                    )}
                </div>
              </Grid.Column>
            </GridRow>
          </Grid>
        )}
      </div>
    );
  }
}

HeaderNavbar.propTypes = {
  userStatusReducer: PropTypes.object,
  navigate: PropTypes.func,
  logoutRequest: PropTypes.func,

  user_status: PropTypes.object,
  screens: PropTypes.array,
  currentScreen: PropTypes.string,
  timeline: PropTypes.array,
  changeScreen: PropTypes.func,
  location: PropTypes.object,
  resetTransactionDetails: PropTypes.func,
  toggleSidebar: PropTypes.func,
  provideToggleMenuParams: PropTypes.func,
  account_type: PropTypes.string,
  user_session: PropTypes.object,
  referred_by_referral_code: PropTypes.string,
  country_code: PropTypes.string,
  destroyUserFlowAction: PropTypes.func,
  featureState: PropTypes.shape({
    toggleFeature: PropTypes.bool
  }),
  transactionDetails: PropTypes.object,
  hard_sme_migrated: PropTypes.any,
  headerRef: PropTypes.object,
  nonHardMigratedSMEFlow: PropTypes.object,
  help_center_notification: PropTypes.bool,
  isNewOnboardingEnabledUser: PropTypes.bool,
  isNiumForexUser: PropTypes.bool,
  niumForexCurrentScreen: PropTypes.string,
  additional_info: PropTypes.object,
  device: PropTypes.string,
  setZenDeskActiveChat: PropTypes.func,
  toggleIsRevampApiCalled: PropTypes.func,

  toggleNewCouponCode: PropTypes.func,
  clearDashboardCalculatorData: PropTypes.func,
  email: PropTypes.string,
  storeSelectedBeneList: PropTypes.func,
  clearDhaChallanData: PropTypes.func
};

function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      userStatusReducer,
      userStatusReducer: user_status,
      userFlowReducer: { screens, currentScreen, timeline },
      transactionReducer: { transactionDetails },
      userSessionReducer: {
        user_session,
        user_session: { account_type, email }
      },
      userDataReducer: {
        userStateInfo: { remitterDetails },
        helpCenterNotificationData
      },
      userStatusReducer: { country_code, nonHardMigratedSMEFlow, additional_info },
      newUserFlowReducer: { new_onboarding_enabled_users: isNewOnboardingEnabledUser },
      niumForexReducer: { isNiumForexUser, currentScreen: niumForexCurrentScreen }
    }
  } = reduxState;
  return {
    userStatusReducer,
    user_status,
    screens,
    currentScreen,
    timeline,
    account_type,
    email,
    user_session,
    referred_by_referral_code: remitterDetails && remitterDetails.referred_by_referral_code,
    country_code,
    transactionDetails,
    nonHardMigratedSMEFlow,
    help_center_notification: helpCenterNotificationData?.help_center_notification,
    isNewOnboardingEnabledUser,
    isNiumForexUser,
    niumForexCurrentScreen,
    additional_info
  };
}

export default withRouterV6(
  connect(mapStateToProps, {
    logoutRequest,
    changeScreen,
    resetTransactionDetails,
    toggleSidebar,
    destroyUserFlowAction,
    setZenDeskActiveChat,
    toggleIsRevampApiCalled,
    toggleNewCouponCode,
    clearDashboardCalculatorData,
    storeSelectedBeneList,
    clearDhaChallanData: () => ({ type: STORE_DHA_CHALLAN_DATA, data: null })
  })(HeaderNavbar)
);
